/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TokenFaucet, TokenFaucetInterface } from "../TokenFaucet";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenRate",
        type: "uint256",
      },
    ],
    name: "addToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "buyFromFaucet",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountToSell",
        type: "uint256",
      },
    ],
    name: "sellToFaucet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "tokenRates",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokens",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type TokenFaucetConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TokenFaucetConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TokenFaucet__factory extends ContractFactory {
  constructor(...args: TokenFaucetConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TokenFaucet> {
    return super.deploy(overrides || {}) as Promise<TokenFaucet>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): TokenFaucet {
    return super.attach(address) as TokenFaucet;
  }
  connect(signer: Signer): TokenFaucet__factory {
    return super.connect(signer) as TokenFaucet__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TokenFaucetInterface {
    return new utils.Interface(_abi) as TokenFaucetInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TokenFaucet {
    return new Contract(address, _abi, signerOrProvider) as TokenFaucet;
  }
}
